import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CogSvg } from './assets/cog.svg';

const CogIcon = React.forwardRef((args, ref) => <SvgIcon component={CogSvg} ref={ref} {...args} />);

export default CogIcon;
